import React from "react";
import MyEarnings from "../screens/Accounts/MyEarnings2";

const MyEarningsPage = () => {
  return <MyEarnings />;
};
export default MyEarningsPage;
